import React, { useState } from 'react';
import './laboratory-table.styles.scss';
import invoice from '../../assets/invoice.png';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { SEND_API } from './api';
import axios from 'axios';

import dateFormat from 'dateformat';

const COLUMNS = [
  { Header: 'UHID', accessor: 'patientId', width: '100px' },
  { Header: 'Patient Name', accessor: 'patientname', width: '320px' },
  { Header: 'DOB', accessor: 'dob', width: '200px' },
  { Header: 'Gender', accessor: 'gender', width: '100px' },
  { Header: 'Visit Type', accessor: 'visitType', width: '150px' },
  { Header: 'Doctor Name', accessor: 'doctorName', width: '150px' },
  // { Header: 'Sample No', accessor: 'labSampleNo', width: '120px' },
  { Header: 'Sample Date', accessor: 'sampleDate', width: '200px' },
  { Header: 'App Date', accessor: 'appDate', width: '180px' },
  { Header: 'Send Msg', accessor: 'sendMsg', width: '100px' },
  { Header: 'Status', accessor: 'appointmentsms', width: '225px' },
  { Header: 'File Path', accessor: 'filepath', width: '225px' },
];

const LaboratoryTable = ({ data, fetchData }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupData, setPopupData] = useState({
    mobile: '',
    patientname: '',
    iden: '',
    appDate: '',
    sendUser: '',
  });
  const [selectedDate, setSelectedDate] = useState({}); // Store selected dates per row

  // Handle date selection
  const handleDateChange = (date, rowIdx) => {
    setSelectedDate((prevDates) => ({
      ...prevDates,
      [rowIdx]: date, // Store selected date with row index
    }));
  };

  // Open popup and fetch latest selected date
  const handlePopupOpen = (rowData, rowIdx) => {
    console.log(selectedDate[rowIdx], 'sjadhskj');
    setPopupData({
      iden: rowData.iden || 'N/A',
      patientname: rowData.patientname || 'N/A',
      // appDate: selectedDate[rowIdx]
      //   ? selectedDate[rowIdx].toISOString()
      //   : rowData.appDate, // Use selected date if available

      appDate: selectedDate[rowIdx]
        ? dateFormat(selectedDate[rowIdx], 'dd-mm-yyyy')
        : dateFormat(rowData.appDate, 'dd-mm-yyyy'), // Use selected date if available

      sendUser: 'meftec',
      mobile: rowData.mobileNumber || 'N/A',
    });

    setIsPopupOpen(true);
  };

  // Send data
  const close = () => {
    setIsPopupOpen(false); // Close the popup after sending
  };
  const send = async () => {
    // if (!popupData.mobile || popupData.mobile === 'N/A') {
    //   alert('No mobile number available to send the message.');
    //   return;
    // }

    const dateParts = popupData.appDate.split('-');
    const formattedDate = new Date(
      `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
    );

    const payload = {
      iden: popupData.iden,
      patientname: popupData.patientname,
      appDate: dateFormat(formattedDate, 'yyyy-mm-dd'),
      sendUser: popupData.sendUser,
      mobile: popupData.mobile,
    };

    try {
      const response = await axios.post(SEND_API, payload);
      console.log('Message sent successfully:', response.data);
      alert('Message sent successfully!');
      setIsPopupOpen(false); // Close the popup after sending
      // window.location.reload();
      fetchData();
    } catch (error) {
      console.error(
        'Error sending message:',
        error.response?.data || error.message
      );
      alert('Failed to send message. Please try again.');
    }
  };

  return (
    <div
      className='laboratory-table'
      style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '500px' }}
    >
      <div className='laboratory-table-container'>
        <table className='laboratory-table-outline'>
          <thead>
            <tr>
              {COLUMNS.map((column, index) => (
                <th key={index} style={{ width: column.width }}>
                  {column.Header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((row, rowIdx) => (
                <tr key={rowIdx}>
                  {COLUMNS.map((column, colIndex) => (
                    <td key={colIndex} style={{ width: column.width }}>
                      {column.accessor === 'sendMsg' ? (
                        <span
                          className='new-visit'
                          onClick={() => handlePopupOpen(row, rowIdx)}
                        >
                          <img
                            className='create-new-icon'
                            alt='Send message'
                            src={invoice}
                          />
                        </span>
                      ) : column.accessor === 'appDate' ? (
                        <DatePicker
                          selected={
                            selectedDate[rowIdx] ||
                            (row[column.accessor]
                              ? new Date(row[column.accessor])
                              : null)
                          }
                          onChange={(date) => handleDateChange(date, rowIdx)}
                          dateFormat='dd-MM-yyyy'
                          className='date-picker'
                          disabledKeyboardNavigation
                          onKeyDown={(e) => e.preventDefault()} // Prevent manual input
                          minDate={new Date()} // Prevent previous dates
                        />
                      ) : column.accessor === 'filepath' ? (
                        <>
                          <a
                            href={row[column.accessor]}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            {row[column.accessor]}
                          </a>{' '}
                        </>
                      ) : (
                        row[column.accessor] || 'N/A'
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={COLUMNS.length} className='no-data'>
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {isPopupOpen && (
        <div className='popup'>
          <div className='popup-content'>
            <h3>Patient Info</h3>
            <p>
              <strong>Name:</strong> {popupData.patientname}
            </p>
            <p>
              <strong>Mobile:</strong> {popupData.mobile}
            </p>
            <p>
              <strong>Appointment Date:</strong> {popupData.appDate}
            </p>
            <button onClick={send}>Send</button>
            <button onClick={close}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LaboratoryTable;
